import { useQuery } from "@tanstack/react-query";
import { getGuardian } from "../../api/apiGuardians";
import i18next from "i18next";
export function useGetGuardian(id) {
    const { isLoading, data: guardian, error } = useQuery({ queryKey: ["guardians", id, i18next.language], queryFn: () => getGuardian(id), enabled: !!id, retry: false });
    return { isLoading, error, guardian };
}
